import { render, staticRenderFns } from "./Tiles.vue?vue&type=template&id=66c2b7ff&scoped=true&"
import script from "./Tiles.vue?vue&type=script&lang=js&"
export * from "./Tiles.vue?vue&type=script&lang=js&"
import style0 from "./Tiles.vue?vue&type=style&index=0&id=66c2b7ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2b7ff",
  null
  
)

export default component.exports